import { baseApi } from "../baseApi";

export const Purchase = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDoctypeDetails: builder.query({
            query: (params) => ({
                url: `/api/method/frappe.client.get`,
                params: params
            })
        }),
        getTaxcategory: builder.query({
            query: () => `/api/resource/Tax Category`,
        }),
        getAllcompany: builder.query({
            query: () => ({
                url: `/api/resource/Company`,
            })
        }),
        getPurchaseTaxList: builder.query({
            query: ({ start, limit, filters }) => {
                return {
                    url: `/api/resource/Purchase Taxes and Charges Template`,
                    params: {
                        fields: JSON.stringify([
                            "`tabPurchase Taxes and Charges Template`.`name`",
                            "`tabPurchase Taxes and Charges Template`.`owner`",
                            "`tabPurchase Taxes and Charges Template`.`creation`",
                            "`tabPurchase Taxes and Charges Template`.`modified`",
                            "`tabPurchase Taxes and Charges Template`.`modified_by`",
                            "`tabPurchase Taxes and Charges Template`.`_user_tags`",
                            "`tabPurchase Taxes and Charges Template`.`_comments`",
                            "`tabPurchase Taxes and Charges Template`.`_assign`",
                            "`tabPurchase Taxes and Charges Template`.`_liked_by`",
                            "`tabPurchase Taxes and Charges Template`.`docstatus`",
                            "`tabPurchase Taxes and Charges Template`.`idx`",
                            "`tabPurchase Taxes and Charges Template`.`is_default`",
                            "`tabPurchase Taxes and Charges Template`.`company`",
                            "`tabPurchase Taxes and Charges Template`.`title`",
                            "`tabPurchase Taxes and Charges Template`.`disabled`"
                        ]),
                        filters: JSON.stringify(filters || []),
                        order_by: "`tabPurchase Taxes and Charges Template`.`modified` desc",
                        limit_start: start,
                        limit_page_length: limit,
                    },
                };
            },
            providesTags: ['Purchase Taxes and Charges Template'],
        }),
        getPurchaseTaxCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.desk.reportview.get_count',
                params: {
                    doctype: 'Purchase Taxes and Charges Template',
                },
            }),
        }),
        createPurchaseTaxTemplate: builder.mutation({
            query: (body) => ({
                url: `/api/resource/Purchase Taxes and Charges Template`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Sales Taxes and Charges Template'],
        }),
        getPurchasetaxByName: builder.query({
            query: (name) => ({
                url: `/api/resource/Purchase Taxes and Charges Template/${encodeURIComponent(name)}`,
                method: "GET",
            }),
            providesTags: ['Sales Taxes and Charges Template']
        }),
        getPurchaseAndChargesAccounts: builder.query({
            query: ({ company }) => {
                const filters = {
                    account_type: ["Tax", "Chargeable", "Expense Account"],
                    company: company
                };

                const params = {
                    reference_doctype: "Sales Taxes and Charges",
                    filters: JSON.stringify(filters),
                    doctype: "Account",
                    txt: "",
                    query: "erpnext.controllers.queries.tax_account_query"
                };

                return {
                    url: `/api/method/frappe.desk.search.search_link`,
                    method: 'GET',
                    params
                };
            }
        }),
        updatepurchaseTax: builder.mutation({
            query: ({ name, payload }) => ({
                url: `/api/resource/Purchase Taxes and Charges Template/${name}`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['Sales Taxes and Charges Template'],
        }),

    }),
});


export const { useUpdatepurchaseTaxMutation, useGetPurchaseTaxListQuery, useGetAllcompanyQuery, useGetTaxcategoryQuery, useGetPurchaseTaxCountQuery, useCreatePurchaseTaxTemplateMutation, useGetPurchasetaxByNameQuery, useGetPurchaseAndChargesAccountsQuery } = Purchase
